export const SimpleCenterLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex items-center justify-center h-screen w-screen">
      <div className="w-full max-w-md bg-white rounded-lg p-8">{children}</div>
    </div>
  );
};
